import { render } from "./locales-input.vue?vue&type=template&id=6425c550&scoped=true"
import script from "./locales-input.js?vue&type=script&lang=js&external"
export * from "./locales-input.js?vue&type=script&lang=js&external"

import "./locales-input.scss?vue&type=style&index=0&id=6425c550&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6425c550"]])

export default __exports__